import Application from "../../Application";
import CaseLawDocumentListPresenter, {
  ICaseLawDocumentListPresenter
} from "../presenter/CaseLawDocumentListPresenter";
import GetAllCaseLawDocumentsInteractor from "./GetAllCaseLawDocumentsInteractor";
import GetAllCaseLawDocumentTypesInteractor from "./GetAllCaseLawDocumentTypesInteractor";
import GetAllOrganisationsInteractor from "../../organisations/interactors/GetAllOrganisationsInteractor";

export default class ShowCaseLawDocumentsInteractor {
  private application: Application;
  private output?: ICaseLawDocumentListPresenter;
  private getAllCaseLawDocumentsInteractor: GetAllCaseLawDocumentsInteractor;
  private getAllCaseLawDocumentTypesInteractor: GetAllCaseLawDocumentTypesInteractor;
  private getAllOrganisationsInteractor: GetAllOrganisationsInteractor;

  constructor({
    application,
    getAllCaseLawDocuments,
    getAllCaseLawDocumentTypes,
    getAllOrganisations
  }: any) {
    this.application = application;
    this.getAllOrganisationsInteractor = getAllOrganisations;
    this.getAllCaseLawDocumentTypesInteractor = getAllCaseLawDocumentTypes;
    this.getAllCaseLawDocumentsInteractor = getAllCaseLawDocuments;
  }

  private async getAllCaseLawDocumentTypes() {
    return this.getAllCaseLawDocumentTypesInteractor.execute();
  }
  private async getAllOrganisations() {
    return this.getAllOrganisationsInteractor.execute();
  }

  private async getReferenceLists() {
    return Promise.all([
      this.getAllCaseLawDocumentTypes(),
      this.getAllOrganisations()
    ]);
  }

  execute() {
    this.output = CaseLawDocumentListPresenter({
      application: this.application,
      initialState: {
        caseLawDocuments: [],
        organisations: [],
        caseLawDocumentTypes: [],
        courtCaseList: []
      }
    });
    this.getReferenceLists()
      .then(([caseLawDocumentTypes, organisations]) =>
        this.output?.loadReferenceValues(caseLawDocumentTypes, organisations)
      )
      .then(() => this.getAllCaseLawDocumentsInteractor.execute())
      .then(this.output.loadAllCaseLawDocuments);
    return this.output;
  }
}
